export interface FeaturesClickHandlerOptions {
  isFeatureButton: (target: HTMLElement) => boolean;
  onFeatureClick: (target: HTMLButtonElement) => void;
}

export const onFeaturesClickHandler = (
  root: HTMLElement,
  { isFeatureButton, onFeatureClick }: FeaturesClickHandlerOptions,
) => {
  const handleFeatureClick = (event: Event) => {
    const target = event.target as HTMLButtonElement;
    if (!target || !isFeatureButton(target)) {
      return;
    }

    onFeatureClick(target);
  };

  root.addEventListener('click', handleFeatureClick);
};
